export const isProduction = () => {
  // ① Vercel builds & runtime  → import.meta.env.VERCEL_ENV
  // ② Local vite dev           → fallback to import.meta.env.MODE
  return (import.meta.env.VERCEL_ENV ?? import.meta.env.MODE) === "production";
};

export const getEnvironment = () => {
  if (typeof window === "undefined") return "production";
  const STAGING_URLS = ["pluto.dev", "plutoxyz.vercel.app"];
  const LOCAL_URLS = ["localhost:"];
  const isStaging = STAGING_URLS.some((url) =>
    window.location.origin.includes(url),
  );
  const isLocal = LOCAL_URLS.some((url) =>
    window.location.origin.includes(url),
  );
  return isStaging ? "staging" : isLocal ? "local" : "production";
};

export const getNotaryUrl = () => {
  const environment = getEnvironment();
  if (environment === "staging") {
    return "https://notary.pluto.dev";
  } else if (environment === "local") {
    return import.meta.env.VITE_NOTARY_URL;
  } else {
    return "https://notary.pluto.xyz";
  }
};

export const getWebSocketUrl = () => {
  const environment = getEnvironment();
  if (environment === "staging") {
    return "wss://notary.pluto.dev";
  } else if (environment === "local") {
    return import.meta.env.VITE_WEBSOCKET_URL;
  } else {
    return "wss://notary.pluto.xyz";
  }
};

export const getFrameUrl = () => {
  const environment = getEnvironment();
  if (environment === "staging") {
    return "https://frame.pluto.dev";
  } else if (environment === "local") {
    return import.meta.env.VITE_FRAME_URL;
  } else {
    return "https://frame.pluto.xyz";
  }
};

export const getBrowserInspectorUrl = () => {
  const environment = getEnvironment();

  if (environment === "staging") {
    return "https://browser-inspector.pluto.dev/inspector.html";
  } else if (
    environment === "local" &&
    import.meta.env.VITE_USE_LOCAL_INSPECTOR === "true"
  ) {
    return "http://localhost:5173/devtools/inspector.html";
  } else {
    return "https://browser-inspector.pluto.xyz/inspector.html";
  }
};
